import { Action } from '@ngrx/store';
import { Reference } from 'src/app/core/utils/action-helper.util';
import { AddPagePayload, AddPageResponse, CopyPagePayload, CopyPageResponse } from '../../_models/page.model';
import { Error } from '../../_models/auth.models';
import { Pages } from '../../_models/settings.models';

/**
 * Pages action types
 */
export enum PagesActionTypes {
  LOAD_PAGES = '[Pages] Load Pages',
  LOAD_PAGES_SUCCESS = '[Pages] Load Pages Success',
  LOAD_PAGES_FAILED = '[Pages] Load Pages Failed',
  LOAD_PAGE = '[Pages] Load Page',
  LOAD_PAGE_SUCCESS = '[Pages] Load Page Success',
  LOAD_PAGE_FAILED = '[Pages] Load Page Failed',
  ADD_PAGE = '[Pages] Add Page',
  ADD_PAGE_SUCCESS = '[Pages] Add Page Success',
  ADD_PAGE_FAILED = '[Pages] Add Page Failed',
  DELETE_PAGE = '[Pages] Delete Page',
  DELETE_PAGE_SUCCESS = '[Pages] Delete Page Success',
  DELETE_PAGE_FAILED = '[Pages] Delete Page Failed',
  UPDATE_PAGE = '[Pages] Update Page',
  UPDATE_PAGE_SUCCESS = '[Pages] Update Page Success',
  UPDATE_PAGE_FAILED = '[Pages] Update Page Failed',
  COPY_PAGE = '[Pages] Copy Page',
  COPY_PAGE_SUCCESS = '[Pages] Copy Page Success',
  COPY_PAGE_FAILED = '[Pages] Copy Page Failed',
  RESET = '[Pages] RESET',
  LOAD_DEFAULT_PAGE_FOR_TABLE = '[Pages] Load Default Page for table',
  LOAD_DEFAULT_PAGE_FOR_TABLE_SUCCESS = '[Pages] Load Default Page for table Success',
  LOAD_DEFAULT_PAGE_FOR_TABLE_FAILED = '[Pages] Load Default Page for table Failed',
}

/**
 * Operations
 */

 export class CopyPage extends Reference implements Action {
  readonly type = PagesActionTypes.COPY_PAGE;

  constructor(public appId: string, public payload: CopyPagePayload) {
    super();
  }
}

export class CopyPageSuccess extends Reference implements Action {
  readonly type = PagesActionTypes.COPY_PAGE_SUCCESS;

  constructor(public payload: CopyPageResponse) {
    super();
  }
}

export class CopyPageFailed extends Reference implements Action {
  readonly type = PagesActionTypes.COPY_PAGE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadPages implements Action {
  readonly type = PagesActionTypes.LOAD_PAGES;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public applicationId: string, public force: boolean = false) {}
}

export class LoadPagesSuccess implements Action {
  readonly type = PagesActionTypes.LOAD_PAGES_SUCCESS;

  constructor(public applicationId: string, public payload: Array<any>) {}
}

export class LoadPagesFailed implements Action {
  readonly type = PagesActionTypes.LOAD_PAGES_FAILED;

  constructor(public payload: Error, public applicationId: string) {}
}

export class LoadPage implements Action {
  readonly type = PagesActionTypes.LOAD_PAGE;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public appId: string, public pageId: string) {}
}

export class LoadPageSuccess implements Action {
  readonly type = PagesActionTypes.LOAD_PAGE_SUCCESS;

  constructor(
    public appId: string,
    public pageId: string,
    public payload: any
  ) {}
}

export class LoadPageFailed implements Action {
  readonly type = PagesActionTypes.LOAD_PAGE_FAILED;

  constructor(public payload: Error) {}
}

export class AddPage extends Reference implements Action {
  readonly type = PagesActionTypes.ADD_PAGE;

  constructor(public payload: AddPagePayload) {
    super();
  }
}

export class AddPageSuccess extends Reference implements Action {
  readonly type = PagesActionTypes.ADD_PAGE_SUCCESS;

  constructor(public payload: AddPageResponse) {
    super();
  }
}

export class AddPageFailed extends Reference implements Action {
  readonly type = PagesActionTypes.ADD_PAGE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class DeletePage extends Reference implements Action {
  readonly type = PagesActionTypes.DELETE_PAGE;

  constructor(public pageId: string, public appId: string) {
    super();
  }
}

export class DeletePageSuccess extends Reference implements Action {
  readonly type = PagesActionTypes.DELETE_PAGE_SUCCESS;

  constructor(public pageId: string, public appId: string) {
    super();
  }
}

export class DeletePageFailed extends Reference implements Action {
  readonly type = PagesActionTypes.DELETE_PAGE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class UpdatePage extends Reference implements Action {
  readonly type = PagesActionTypes.UPDATE_PAGE;

  constructor(public payload: AddPagePayload) {
    super();
  }
}

export class UpdatePageSuccess extends Reference implements Action {
  readonly type = PagesActionTypes.UPDATE_PAGE_SUCCESS;

  constructor(public payload: Pages) {
    super();
  }
}

export class UpdatePageFailed extends Reference implements Action {
  readonly type = PagesActionTypes.UPDATE_PAGE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class Reset implements Action {
  readonly type = PagesActionTypes.RESET;

  constructor() {}
}

export class LoadDefaultPageForTable implements Action {
  readonly type = PagesActionTypes.LOAD_DEFAULT_PAGE_FOR_TABLE;
  appId: any;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public TableId: string, public force: boolean = false) {}
}

export class LoadDefaultPageForTableSuccess implements Action {
  readonly type = PagesActionTypes.LOAD_DEFAULT_PAGE_FOR_TABLE_SUCCESS;

  constructor(public tableId: string, public payload: Array<any>) {}
}

export class LoadDefaultPageForTableFailed implements Action {
  readonly type = PagesActionTypes.LOAD_DEFAULT_PAGE_FOR_TABLE_FAILED;

  constructor(public payload: Error) {}
}

/**
 * Available types
 */
export type Actions =
  | LoadPages
  | LoadPagesSuccess
  | LoadPagesFailed
  | LoadPage
  | LoadPageSuccess
  | LoadPageFailed
  | AddPage
  | AddPageSuccess
  | AddPageFailed
  | DeletePage
  | DeletePageSuccess
  | DeletePageFailed
  | UpdatePage
  | UpdatePageSuccess
  | UpdatePageFailed
  | Reset
  | CopyPage
  | CopyPageSuccess
  | CopyPageFailed
  | LoadDefaultPageForTable
  | LoadDefaultPageForTableSuccess
  | LoadDefaultPageForTableFailed;
